import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Router } from '@angular/router';

@Component({
  selector: 'ps-demo-video',
  templateUrl: './demo-video.component.html',
  styleUrls: ['./demo-video.component.scss']
})
export class DemoVideoComponent implements OnInit {
  public openNav: boolean = false;

  constructor(private sanitizer: DomSanitizer, private router: Router) { }
  ngOnInit() { }

  openMobileNav() {
    this.openNav = !this.openNav;
  }

  getSafeUrl(url: string): SafeResourceUrl {
    if (typeof url !== 'string' || url.trim() === '') {
      return this.sanitizer.bypassSecurityTrustResourceUrl(''); // empty safe URL
    }

    let videoId = '';

    if (url.includes('watch?v=')) {
      videoId = url.split('watch?v=')[1].split('&')[0];
    } else if (url.includes('youtu.be/')) {
      videoId = url.split('youtu.be/')[1].split('?')[0];
    } else if (url.includes('youtube.com/embed/')) {
      videoId = url.split('embed/')[1].split('?')[0];
    }

    const embedUrl = `https://www.youtube-nocookie.com/embed/${videoId}?rel=0&modestbranding=1&controls=1&disablekb=1&iv_load_policy=3&fs=1&cc_load_policy=0&showinfo=0&playsinline=1`;

    return this.sanitizer.bypassSecurityTrustResourceUrl(embedUrl);
  }
  back() {
    this.router.navigate(['/auth/login']);
  }

}
